<template>
  <el-dialog
      v-el-drag-dialog
      class="adaptationModal"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="变更记录"
      width="1100px"
      @close="close()">
    <Table 
        v-loading="contentLoading" 
        border 
        stripe
        height="500"
        :columns="columns" 
        :data="data"/>
    <handle-detail v-if="billId!=='null'" :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    <span slot="footer">
      <el-button @click="close()">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail";
  export default {
    name: "",
    components: { HandleDetail },
    data() {
      return {
        dialogVisible: false,
        billId: "0",
        billType: "0",
        // billType: "0",
        columns: [
          {
            title: "文件类型",
            key: "fileTypeName",
            width: 100,
            align: "center",
          },
          {
            title: "文件名称",
            key: "fileName",
            tooltip: true,
            minWidth: 200,
          },
          {
            title: "文件路径",
            key: "filePath",
            tooltip: true,
            minWidth: 200,
            render: (h, params) => {
              return h(
                "span", {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.filePath);
                    },
                  },
                },
                params.row.filePath,
              );
            },
          },
          {
            title: "版本",
            key: "version",
            align: "center",
            width: 80,
          },
          {
            title: "创建人",
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            title: "创建时间",
            key: "createTime",
            width: 180,
            align: "center",
          },
        ],
        data: [],
        contentLoading: false,
      };
    },
    methods: {
      download(filePath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      open(row,id,type) {
        this.dialogVisible = true;
        this.billId = id;
        this.billType = type;
        this.data = row.detailVos;
      },
      close() {
        this.dialogVisible = false;
        this.billId = "null";
        this.billType = "";
      },
      getData(pkId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `esops/${pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.data = resp.data.detailVos;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },
    },
  };
</script>
